// Auto-generated from proto definitions. DO NOT EDIT.

export type DeploymentMode = 'DEPLOYMENT_MODE_UNSPECIFIED' | 'DEPLOYMENT_MODE_CLOUD' | 'DEPLOYMENT_MODE_ONPREM';

export const DeploymentModeValues = ['DEPLOYMENT_MODE_UNSPECIFIED', 'DEPLOYMENT_MODE_CLOUD', 'DEPLOYMENT_MODE_ONPREM'] as const;
